import makeStyles from "@material-ui/core/styles/makeStyles";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import React from "react";
import { Filter, ReferenceInput, useTranslate } from "react-admin";

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { ToggleDatesEnum, ToggleDatesFilter } from "../../../components/filters/ToggleDatesFilter";
import { ToggleTitleInput } from "../../../components/filters/ToggleInputs";
import { ToggleStateFilter } from "../../../components/filters/ToggleStateFilter";
import {
	TERMINAL_DEFAULT_VALUE,
} from "../../../components/filters/ToggleTerminalsFilter";
import { DateInput } from "../../../components/inputs/DateTimeInput";
import { OSFCUserSelectInput } from "../../../components/inputs/OSFCUserSelect";
import TerminalDatesInput from "../../../components/inputs/TerminalDatesInput";
import { SelectUppercaseInput } from "../../../components/inputs/SelectUppercaseInput";
import { filterColors } from "../../../utils/constants";
import { ServiceInput } from "../forms/inputs/ServiceInput";
import { envSettings } from 'core/EnvSettings';

export const filterDefaultValues = {
	named_eta_etd_datetime: [ToggleDatesEnum.TODAY],
	terminal_id: [TERMINAL_DEFAULT_VALUE],
};

const useStyles = makeStyles((t) => ({
	filterSearch: {
		backgroundColor: filterColors.search,
	},
}));

const REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN = envSettings.REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN;

export const TasksFilter = ({ isSearchMode, ...props }) => {
	const translate = useTranslate();
	const classes = useStyles();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const terminalId = globalFilters?.terminal_id?.[0];

	return (
		<Filter {...props}>
			{!isSearchMode && [
				<ToggleDatesFilter
					hiddenButtons={{
						[ToggleDatesEnum.FOUR_HOURS_AHEAD]: REACT_APP_4_HOURS_AHEAD_FILTER__HIDDEN,
					}}
					source="named_eta_etd_datetime"
					defaultValue={null}
					alwaysOn
				/>,

				<ToggleStateFilter
					source="status_state"
					defaultValue={undefined}
					alwaysOn
					key={"status_state"}
				/>,

				<TextInputEx source="id" key="id" />,

				<TextInputEx source="rank" key="rank" />,

				<ServiceInput source="service" resettable key={"service"} />,

				<ReferenceInput source="status" reference="task-statuses" resettable key="status">
					<SelectUppercaseInput optionText="name" />
				</ReferenceInput>,

				<OSFCUserSelectInput source="assignee_1" key="assignee_1" />,

				<TerminalDatesInput component={DateInput} source="eta_date" margin="dense" resettable key="eta_date" priorityRecord={{ terminal_id: terminalId }} />,

				<TerminalDatesInput component={DateInput} source="etd_date" margin="dense" resettable key="etd_date" priorityRecord={{ terminal_id: terminalId }} />,
			]}

			<ToggleTitleInput
				source="is_search"
				value={true}
				key={"is_search"}
				label0={translate("osfc.filters.toggles.search")}
				label1={translate("osfc.filters.toggles.back_to_tasks")}
				alwaysOn
				className={classes.filterSearch}
			/>

			{isSearchMode && (
				<TextInputEx label={translate("osfc.filters.toggles.docs_search")} source="doc_search_text" alwaysOn />
			)}
		</Filter>
	);
};
